export const SET_DIGITAL_CORE_DATA = "SET_DIGITAL_CORE_DATA";

export const setDigitalCoreData = (data) => ({
  type: SET_DIGITAL_CORE_DATA,
  payload: data,
});
